"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _api = require("@react-google-maps/api");

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var libraries = ["places"];
/**
 * A wrapper component to provide Google API key to children that rely on the Google API to reduce unusual errors and multiple API requests.
 *
 * Children wrapped within this wrapper should not be given a API key.
 *
 * This wrapper should be used when more than one Goodle API component is used on the same page.
 *
 * Refer to @react-google-maps/api Github documentation.
 * @summary Google API provider.
 * @param {object} props - Component props
 * @param {string=} props.googleApiKey - A Google API key that must be authenticated to use the correct API's
 * @param {JSX.Element=} props.children - Children components to be passed into map component. Refer to @react-google-maps/api Github documentation.
 */

var GoogleMapApiWrapper = function GoogleMapApiWrapper(_ref) {
  var googleApiKey = _ref.googleApiKey,
      children = _ref.children;

  var _useLoadScript = (0, _api.useLoadScript)({
    googleMapsApiKey: googleApiKey,
    libraries: libraries
  }),
      isLoaded = _useLoadScript.isLoaded,
      loadError = _useLoadScript.loadError;

  var displayStatus = function displayStatus() {
    if (!googleApiKey || loadError) {
      return _react["default"].createElement(_Text["default"], null, "Error connecting to Google");
    }

    if (!isLoaded) {
      return _react["default"].createElement(_Spinner["default"], {
        color: "primary.0"
      });
    }

    return _react["default"].createElement(_react["default"].Fragment, null, children);
  };

  return displayStatus();
};

var _default = GoogleMapApiWrapper;
exports["default"] = _default;